import {RenderAugmentation} from "../types";
import {accountingTable} from "./accounting-table/augmentation";
import {stikkord} from "./stikkord/augmentation";
import {sectionIconLinks} from "./section-icon-links/augmentation";

// Section-icon-links runs BEFORE stikkord so that the header-wrapping
// step sees the raw section children (no Stikkord component present yet).
// Otherwise, the heuristic that picks the heading inside
// `SectionIconLinks` can latch onto a Stikkord-augmented child and
// wrap the wrong element in `<header>`. Order-dependence is intentional —
// see `renderNode.test.tsx` for the invariant.
export const augmentations: RenderAugmentation[] = [
    accountingTable,
    sectionIconLinks,
    stikkord,
];
